import { PaginationModel } from '@_types/molecules';
import { MouseEventHandler } from 'react';
import { getModifiers } from '@helpers/functions';

type Props = {
  handlePageChange?: MouseEventHandler;
  isBall?: boolean;
} & PaginationModel;

const Pagination = (model: Props) => {
  const { pages, handlePageChange, isBall } = model;
  const modifiers = getModifiers(model, 'kf-m-pagination');

  return (
    <div className={modifiers}>
      {pages &&
        pages.map((page) => (
          <a
            key={page.label}
            className={`kf-m-pagination__page ${isBall ? 'ball' : ''} ${page.isCurrentPage && 'kf-m-pagination__page--current'} ${page.isLastPage && 'kf-m-pagination__page--lastpage'}`}
            data-current-page={page.isCurrentPage || undefined}
            data-pager={page.label}
            href={page.url}
            tabIndex={0}
            onClick={handlePageChange}
          >
            {isBall ? '' : page.label}
          </a>
        ))}
    </div>
  );
};

export default Pagination;
